angular.module('app').controller('StatementsLoginCtrl',
    ['$scope','$rootScope','TransitionManager', 'LocalStorageRepository','ContentAttributeService','GatewayFactory','Bridge', 'aprgettext','$stateParams','LogOffService','$log','AprimaAnalytics','configuration','PatientSettingsService',
        function ($scope,$rootScope, TransitionManager, LocalStorageRepository,ContentAttributeService,GatewayFactory, Bridge, gettext, $stateParams, LogOffService, $log, AprimaAnalytics, configuration, PatientSettingsService) {
            'use strict';

            $log.info('LoginCtrl starting up');

            $scope.birthDateRegex = /^$|\d{4}\-\d{2}\-\d{2}/ ;
            $scope.phoneRegEx = /\(?\d{3}(-|\))?\s?\d{3}-?\d{4}$/;
            $scope.zipCodeRegex = /^$|\d{5}/ ;
            $scope.practiceName = null;
            $scope.statementId = $stateParams.statementId;
            $scope.gateways = _.map(_.cloneDeep(configuration.GATEWAYS), function (g) {
                g.display = g.prefix + ' - ' + g.url;
                return g;
            });

            $scope.model =
                {
                clientID: LocalStorageRepository.getClientID() || '0',
                birthDate: '',
                zipCode: '',
                accessCode:'',
                gateway: null,
                practiceName: '',
                practiceTagline: '',
                userId:  ''
                };



            AprimaAnalytics.sendPageView('/StatementsLogin');
            LogOffService.logoff();

            function loadPracticeInfo() {
                ContentAttributeService.getPracticeInfo(true)
                    .then(function (practiceInfo) {
                        $scope.model.practiceName = practiceInfo.practiceName;
                        $scope.model.practiceTagline = practiceInfo.practiceTagline;
                    })
                    .catch(function () {
                        $scope.model.practiceName = '';
                        $scope.model.practiceTagline = '';
                    });
            }

            if (!configuration.DEV_HOSTED) {
                ContentAttributeService.getClientConfig()
                    .then(function (data) {
                        if (data) {
                            var oldClientId = LocalStorageRepository.getClientID();

                            if (oldClientId !== data.clientId) {
                                LocalStorageRepository.clearAll();
                            }

                            LocalStorageRepository.setClientURL(data.hostUrl);
                            LocalStorageRepository.setClientID(data.clientId);

                        } else {
                            $scope.errorMessage = gettext('Error loading page. Unknown Client Id');
                            Bridge.createModalAlert({
                                title: gettext('Loading Error'),
                                message: $scope.errorMessage,
                                buttons: [gettext('Okay')]
                            });
                        }
                    }).catch(function () {
                    $scope.errorMessage = gettext('Error loading page. Unknown Client Id');
                    Bridge.createModalAlert({
                        title: gettext('Loading Error'),
                        message: $scope.errorMessage,
                        buttons: [gettext('Okay')]
                    });
                });
            }

            function onLoad() {
                loadPracticeInfo();
            }

            onLoad();

            function loginProcess()
            {
                if ($scope.loading) {
                    return;
                }

                if ($scope.loginForm.$invalid) {
                    $scope.submitted = true;
                    return;
                }

                $scope.loading = true;
                var phoneNumberScrubbed = $scope.model.phoneNumber && $scope.model.phoneNumber.replace(/\D/g,'');

                GatewayFactory.loginStatementsOnly(LocalStorageRepository.getClientID(), $scope.model.birthDate, $scope.model.zipCode, $scope.model.accessCode.toUpperCase(), phoneNumberScrubbed, $scope.model.gateway ? $scope.model.gateway.prefix : null)
                    .then(function () {
                        // Broadcast event to start application timeout logic.
                        // Please see 'modules\app\app.js' for application timeout configuration and documentation.
                        $rootScope.$broadcast('IdleStartWatch');
                        PatientSettingsService.getPatientFeatures();
                        TransitionManager.transition({appRoute: 'paymentStatementsOnly'});

                    }, function (err) {
                        $scope.errorMessage = '\nLogin failure.\nYou have entered incorrect login information\n';

                        Bridge.createModalAlert({
                            title: gettext('Login Error.'),
                            message: err.message,
                            buttons: [gettext('Okay')]
                        });
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            $scope.loginProcess = loginProcess;
        }
    ]
);

